export default "__VITE_ASSET__69752036__"